import { Link, useLocation } from "react-router-dom";
import { useUser } from "@clerk/react";
import { LayoutDashboardIcon, ShieldUserIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { useComplianceRole } from "@/hooks/IsAdminContext";

const AREAS = [
  { path: "/dashboard", label: "Dashboard", icon: LayoutDashboardIcon },
  { path: "/manager", label: "Manager", icon: ShieldUserIcon },
];

/**
 * Header switch between /dashboard and the staff-only /manager area —
 * rendered for Uplodio staff (Clerk publicMetadata uplodio_member) only.
 * Styled like TabsList/TabsTrigger, but real links.
 */
export function AreaSwitch() {
  const { user } = useUser();
  const { isCompliance } = useComplianceRole();
  const { pathname } = useLocation();
  const isStaff = Boolean(
    (user?.publicMetadata as Record<string, unknown> | undefined)?.uplodio_member
  );
  if (!isStaff || isCompliance) return null;

  return (
    <nav
      aria-label="Switch area"
      className="bg-muted text-muted-foreground/70 inline-flex h-auto shrink-0 items-center rounded-md p-0.5"
    >
      {AREAS.map(({ path, label, icon: Icon }) => {
        const active = pathname.startsWith(path);
        return (
          <Link
            key={path}
            to={path}
            aria-current={active ? "page" : undefined}
            title={label}
            className={cn(
              "hover:text-foreground focus-visible:ring-ring/20 flex size-7 items-center justify-center rounded-sm text-xs font-medium whitespace-nowrap transition-all outline-none focus-visible:ring-[3px] [&_svg]:size-3.5 [&_svg]:shrink-0",
              active && "bg-background text-foreground shadow-xs"
            )}
          >
            <Icon aria-hidden="true" />
          </Link>
        );
      })}
    </nav>
  );
}
